export const createAbsoluteURL = (path: string): string => {
  const protocol = window.location.protocol;
  const host = window.location.host;
  return `${protocol}://${host}`.concat(path);
};
